import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.png';
import { useAppLanguage } from '../../Hooks/useAppLanguage';
import './CheckoutFlowHeader.css';

const CheckoutFlowHeader = ({ backTo = '/cart', backLabel }) => {
    const { t, langPath } = useAppLanguage();

    return (
        <header className="checkout-flow-header">
            <div className="container checkout-flow-header-inner">
                <Link to={langPath('/')} className="checkout-flow-logo">
                    <img src={Logo} alt={t('breadcrumb.home')} />
                </Link>
                <Link to={langPath(backTo)} className="checkout-flow-back">
                    {backLabel || t('checkout.goBack')}
                </Link>
            </div>
        </header>
    );
};

export default CheckoutFlowHeader;
